import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["aside", "overlay"]

  open() {
    this.asideTarget.classList.remove("-translate-x-full")
    this.overlayTarget.classList.remove("hidden")
  }

  close() {
    this.asideTarget.classList.add("-translate-x-full")
    this.overlayTarget.classList.add("hidden")
  }
}
